import React from "react";

import classes from "./styles.module.css";

function TableRow({data}) {

    return (
        <tr>
            <td className={classes.CellLeft}>{data[0]}</td>
            <td>{data[1]}</td>
            <td>{data[2]}</td>
            <td className={classes.Success}>{data[3]}</td>
            <td className={classes.Decline}>{data[4]}</td>
        </tr>
    )
}

export default TableRow;


// WEBPACK FOOTER //
// ./src/Components/Charts/CountryTop/TableRow.js